export default function ({ route, store }) {
  const { caseId } = route.params;
  const isMaydayWeb = route.path.split('/')[1] === 'web';
  const isWebParametric = route.path.split('/')[1] === 'web-parametric';
  if (caseId && !isMaydayWeb && !isWebParametric) {
    store.dispatch('knowledgeModule/setFocusCollectionId', caseId);
  }
}
